// extracted by mini-css-extract-plugin
export var label = "_ao-1";
export var reminder = "_ao-0";